import React, { useState } from "react";
import StoreAction from "../constants/store-action";
import { validateTradeIn } from "../tools/data-validation";
import { VehicleCondition } from "@wayke-se/ecom";
import Alert from "../components/alert";
import Spinner from "../components/spinner";
import UserEvent from "../constants/user-event";
export default (props) => {
    const [hasRequestError, setHasRequestError] = useState(false);
    const pickConditionVeryGood = () => handlePickConditionClick(VehicleCondition.VeryGood);
    const pickConditionGood = () => handlePickConditionClick(VehicleCondition.Good);
    const pickConditionOk = () => handlePickConditionClick(VehicleCondition.Ok);
    const handlePickConditionClick = (condition) => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "tradeInCar",
            name: "condition",
            value: condition,
        });
        onNextStep();
    };
    const onNextStep = () => {
        const isValidData = validateTradeIn(props.data.tradeInCar);
        if (!isValidData) {
            return props.dispatchStoreAction(StoreAction.INTERACT_SET_ALL_FOR_TYPE, "tradeInCar");
        }
        setHasRequestError(false);
        props.onFetchVehicleInformation((isSuccessful) => {
            if (isSuccessful) {
                props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
                    type: "tradeInCar",
                    name: "hasProvidedTradeInCondition",
                    value: true,
                }, () => {
                    props.onIncompleteUserEvent(UserEvent.TRADE_IN_DEFINED);
                    props.onProceedToNextStep();
                });
            }
            else {
                setHasRequestError(true);
            }
        });
    };
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Skick"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null, "V\u00E4lj det alternativ som passar bilens skick b\u00E4st."))),
        !props.isWaitingForResponse && !hasRequestError && (React.createElement("section", { className: "page-section page-section-accent" },
            React.createElement("div", { className: "repeat-m-half" },
                React.createElement("div", { "data-ecom-box": "light" },
                    React.createElement("h2", { className: "h6" }, "Mycket bra skick"),
                    React.createElement("div", { "data-ecom-content": "" },
                        React.createElement("ul", null,
                            React.createElement("li", null, "Inga repor eller skador"),
                            React.createElement("li", null, "Servad vid varje tillf\u00E4lle med st\u00E4mplar i serviceboken"),
                            React.createElement("li", null, "D\u00E4ck med v\u00E4ldigt bra m\u00F6nsterdjup (5-8 mm)"))),
                    React.createElement("div", { className: "box-footer box-footer-right" },
                        React.createElement("button", { "data-ecom-button": "small", onClick: pickConditionVeryGood }, "V\u00E4lj")))),
            React.createElement("div", { className: "repeat-m-half" },
                React.createElement("div", { "data-ecom-box": "light" },
                    React.createElement("h2", { className: "h6" }, "Bra skick"),
                    React.createElement("div", { "data-ecom-content": "" },
                        React.createElement("ul", null,
                            React.createElement("li", null, "N\u00E5gra mindre repor och/eller skador"),
                            React.createElement("li", null, "Servad vid varje tillf\u00E4lle med st\u00E4mplar i serviceboken"),
                            React.createElement("li", null, "D\u00E4ck som inte beh\u00F6ver bytas (m\u00F6nsterdjup om 3-5 mm)"))),
                    React.createElement("div", { className: "box-footer box-footer-right" },
                        React.createElement("button", { "data-ecom-button": "small", onClick: pickConditionGood }, "V\u00E4lj")))),
            React.createElement("div", { className: "repeat-m-half" },
                React.createElement("div", { "data-ecom-box": "light" },
                    React.createElement("h2", { className: "h6" }, "Helt okej skick"),
                    React.createElement("div", { "data-ecom-content": "" },
                        React.createElement("ul", null,
                            React.createElement("li", null, "Finns en del repor och skador"),
                            React.createElement("li", null, "Inte servad vid varje tillf\u00E4lle"),
                            React.createElement("li", null, "D\u00E4ck som beh\u00F6ver bytas (m\u00F6nsterdjup under 3 mm)"))),
                    React.createElement("div", { className: "box-footer box-footer-right" },
                        React.createElement("button", { "data-ecom-button": "small", onClick: pickConditionOk }, "V\u00E4lj")))))),
        hasRequestError && (React.createElement("section", { className: "page-section" },
            React.createElement(Alert, { message: `Tyvärr fick vi ingen träff på registreringsnumret ${props.data.tradeInCar.registrationNumber}. Kontrollera registreringsnumret igen eller gå vidare utan inbytesbil (kan kompletteras vid senare kontakt med handlaren).` }))),
        props.isWaitingForResponse && (React.createElement("section", { className: "page-section" },
            React.createElement(Spinner, null)))));
};
